module.exports = __webpack_public_path__ + "static/media/Crew.b5e1d7d5.svg";